/*
    This file is included in master.cshtml.
    Include a file here, for it to be ran globally.

    You can also scope a file to a page / partial, by doing the following:
    @section scripts {
        <script type="module" src="~/dist/bundle/components/myPageSpecificScript.js" defer></script>
    }
*/

import "./components/logoutComponent.js"
import "./components/mobileMenuComponent.js"
import "./components/compliancePopupComponent.js"
import "./components/quoteComponent.js"
import "./carousel.js"
